import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const Title = styled.p`
  font-size: 1rem;
  font-weight: bold;
  min-height: 2rem;
`;

export const IconContaniner = styled.div`
  position: absolute;
  background: ${colors.GREEN_LEAF};
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 0.2rem;
  z-index: 100;
  right: 1.5rem;
  top: 1.75rem;
  cursor: pointer;
`;

export const ContainerStyle = {
  position: 'relative',
  width: 360,
  marginBottom: '1rem',
  marginTop: '1rem',
  display: 'flex',
};

export default {
  Title,
  IconContaniner,
  ContainerStyle,
};
